import React from "react";
import { Link } from "react-router-dom";

export function TermsCheckbox({ id, checked, onChange, testid, termsTestid, privacyTestid }) {
  return (
    <label htmlFor={id} className="flex items-start gap-3 mt-2 mb-4 cursor-pointer select-none">
      <input id={id} data-testid={testid} type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 h-5 w-5 shrink-0 rounded border-slate-300 text-[#008057] focus:ring-[#008057] accent-[#008057]" />
      <span className="text-sm text-slate-600 leading-relaxed">
        I have read and agree to the{" "}
        <Link to="/terms" target="_blank" data-testid={termsTestid} className="text-[#008057] font-semibold hover:underline">Terms &amp; Conditions</Link>
        {" "}and{" "}
        <Link to="/privacy" target="_blank" data-testid={privacyTestid} className="text-[#008057] font-semibold hover:underline">Privacy Policy</Link>.
      </span>
    </label>
  );
}
